<div class="container px-4 pb-4">
  <app-shared-action-bar [saveReady]="unsavedChanges" [undoReady]="unsavedChanges"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="validate()"
  (undoRequest)="resetCurrentUser()"></app-shared-action-bar>
  <div class="mt-20">

    <h2 class="settings-header mx-4">Manage Users</h2>
    <div class="mt-3 lg:mt-8 border-solid mx-4 xl:ml-8 ">
      @if (!editing) {
        <table class="lg:block hidden my-4 w-full table-auto xl:w-3/5">
          <thead>
            <tr class="pb-3">
              <th class="text-left">Display Name</th>
              <th class="text-left">Email Address</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (u of mobileList; track u) {
              <tr class="border-b-2 border-grey-100"
                [ngClass]="{'hidden':u.Disabled}">
                <td class="px-4">
                  {{u.DisplayName}}
                </td>
                <td>
                  {{u.Email}}
                </td>
                <td class="pt-2 pl-2">
                  <span (click)="selectUser(u)" class="material-symbols-outlined hover:cursor-pointer">chevron_right</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (!editing) {
        <div class="lg:hidden">
          <select class="text-box" [(ngModel)]="currentUser" (change)="selectMobileUser()">
            @for (u of mobileList; track u) {
              <option [ngValue]="u" [disabled]="u.Disabled">{{u.DisplayName}}
              </option>
            }
          </select>
        </div>
      }
      @if (editing) {
        <div>
          <div class="flex items-center">
            <h2 class="text-lg font-bold">{{currentUser.DisplayName}}</h2><span  (click)="switchEditing()" class="ml-2 material-symbols-outlined hover:cursor-pointer">edit</span>
          </div>
          <div class="xl:w-3/5 lg:w-4/5 mt-5">
            @if (!isGroup) {
              <div class="mb-4">
                @if (currentUser.HasLoggedIn) {
                  <div
                    class="my-4 p-4 border-solid border-2 rounded-lg border-grey-300">
                    <p class="text-lg font-bold">Active Account</p>
                    <p>Once an account has successfully logged in the account details can only be updated by the
                      user or by contacting our support team. The account can still be made inactive below.
                    </p>
                    <a href="mailto:care@careaudits.co.uk" class="text-green-700 ">Contact Support</a>
                  </div>
                }
                <label class="mr-2">Username</label>
                <input type="text" [disabled]="currentUser.HasLoggedIn"
                  [ngClass]="{'text-grey-900':currentUser.HasLoggedIn}" class="text-box"
                  [(ngModel)]="currentUser.Username" (ngModelChange)="resetFlags()" (keyup)="checkForChange()" />
                  @if (invalidUserName) {
                    <p>Username is invalid</p>
                  }
                  @if (isUsernameInUse) {
                    <p>Username must be unique, please select a different username</p>
                  }
                </div>
              }
              <div class="mb-4">
                @if (!isGroup) {
                  <label class="mr-2">Display Name</label>
                }
                @if (isGroup) {
                  <label class="mr-2">Group Name</label>
                }
                <input type="text" class="text-box" [disabled]="currentUser.HasLoggedIn && !isGroup" (keyup)="checkForChange()"
                  [ngClass]="{'text-grey-900':currentUser.HasLoggedIn && !isGroup, 'error': invalidDisplayName}"
                  [(ngModel)]="currentUser.DisplayName" (ngModelChange)="resetFlags()" />
                  @if (invalidDisplayName) {
                    <p class="form-error">Display Name is not valid</p>
                  }
                </div>
                @if (!isGroup) {
                  <div class="mb-8">
                    <label class="mr-2">Email</label>
                    <input type="email" class="text-box" [disabled]="currentUser.HasLoggedIn" (keyup)="checkForChange()"
                      [ngClass]="{'text-grey-900':currentUser.HasLoggedIn, 'error':invalidEmail || emailUsed}"
                      [(ngModel)]="currentUser.Email" (ngModelChange)="resetFlags()" />
                      @if (invalidEmail) {
                        <p class="form-error">Email is invalid</p>
                      }
                      @if (emailUsed) {
                        <p class="form-error">Email is already assigned to an account</p>
                      }
                    </div>
                  }
                  <div class="flex">
                    <label class="mr-4">Active</label>
                    <app-toggle-switch [(checked)]="currentUser.Active" (checkedChange)="checkForChange()"></app-toggle-switch>
                  </div>
   
              </div>
            </div>
          }
        </div>



      </div>